// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_PROPOSAL = 'GET_PROPOSAL';
export const CREATE_PROPOSAL = 'CREATE_PROPOSAL';
export const GET_PROPOSAL_BY_ID = 'GET_PROPOSAL_BY_ID';
export const UPDATE_PROPOSAL = 'UPDATE_PROPOSAL';
export const DELETE_PROPOSAL = 'DELETE_PROPOSAL';
export const CHECK_CPF_PROPOSAL = 'CHECK_CPF_PROPOSAL';
export const GET_PROPOSAL_ASSOCIATES = 'GET_PROPOSAL_ASSOCIATES';
export const CANCEL_PROPOSAL = 'CANCEL_PROPOSAL';
export const CHANGE_STATUS = 'CHANGE_STATUS';
export const REACTIVE_PROPOSAL = 'REACTIVE_PROPOSAL';
